import { useEffect, useRef, useState } from "react";
import { Col, Modal, Row } from "react-bootstrap";

import { PaginationDots } from "features/components/base/public/HOC/Pagination";
import { MediaThumbnailsSync } from "shared/video-thumbnail/MediaThumbnail";
import { downArrowIcon, playIcon, upArrowIcon } from "shared/assets/icons";

import './ItemGalleryHOC.scss';

const VideoPlayer = ({ url, autoPlay=true }) => {
    return (
        //poster={currentThumbnailArray[0]}
        <video preload="none" autoPlay={autoPlay} controls disablePictureInPicture controlsList="nodownload" webkit-playsinline playsinline >
            <source src={url}></source>
            Your browser does not support HTML video.
        </video>
    )
};

export const ItemGalleryHOC = ({ list = [], galleryInModal = false}) => {

    const imageScrollRef = useRef(null);
    const horizontalScrollRef = useRef(null);

    const magnifier = useRef(null);
    const magnifierImage = useRef(null);

    const [activeImage, setActiveImage] = useState(list.length > 0 ? list[0] : {});
    const [videos, setVideos] = useState([]);
    const [videoThumbnails, setVideoThumbnails] = useState({});
    const [magnifierHide, setMagnifierHide] = useState(true);
    const [videoPlayerModal, setVideoPlayerModal] = useState(false);

    useEffect(() => {
        setActiveImage(list.length > 0 ? list[0] : {});
        setVideos(list.filter(asset => asset.type === 'video'));
      return () => {
      }
    }, [list]);

    const handleScroll = (direction) => {
        /* Scroll up or down with animation */
        direction === 'Down' ? imageScrollRef.current.scrollTo({
            top: (imageScrollRef.current.scrollTop + 150),
            behavior: 'smooth'
        }) : imageScrollRef.current.scrollTo({
            top: (imageScrollRef.current.scrollTop - 150),
            behavior: 'smooth'
        });
    };

    const moveMagnifier = (e) => {
        const isdefaultImage = Array.isArray(list) && list.length == 1 && !list[0].id;
        if (!isdefaultImage) {
            let pos, x, y;
            const zoom = 4;

            const img = magnifierImage.current;
            const glass = magnifier.current;

            glass.style.backgroundSize = (img.width * zoom) + "px " + (img.height * zoom) + "px";

            const bw = 3;
            const w = glass.offsetWidth / 2;
            const h = glass.offsetHeight / 2;

            /*prevent any other actions that may occur when moving over the image*/
            e.preventDefault();

            /*get the cursor's x and y positions:*/
            pos = getCursorPos(e);
            x = pos.x;
            y = pos.y;

            /*prevent the magnifier glass from being positioned outside the image:*/
            if (x > img.width - (w / zoom)) { x = img.width - (w / zoom); }
            if (x < w / zoom) { x = w / zoom; }
            if (y > img.height - (h / zoom)) { y = img.height - (h / zoom); }
            if (y < h / zoom) { y = h / zoom; }

            /*set the position of the magnifier glass:*/
            glass.style.left = (x - w) + "px";
            glass.style.top = (y - h) + "px";

            /*display what the magnifier glass "sees":*/
            glass.style.backgroundPosition = "-" + ((x * zoom) - w + bw) + "px -" + ((y * zoom) - h + bw) + "px";
        }
    };

    const getCursorPos = (e) => {
        let a, x = 0, y = 0;

        const img = magnifierImage.current;

        e = e || window.event;

        /*get the x and y positions of the image:*/
        a = img.getBoundingClientRect();

        /*calculate the cursor's x and y coordinates, relative to the image:*/
        x = e.pageX - a.left;
        y = e.pageY - a.top;

        /*consider any page scrolling:*/
        x = x - window.pageXOffset;
        y = y - window.pageYOffset;
        return { x: x, y: y };
    };

    const toggleMagnifier = (event, value, flag) => {
        if (flag === 'enter' && !magnifierHide) {
            setMagnifierHide(value);
        } else {
            setMagnifierHide(value);
        }
    };

    const onImageClick = (media) => {
        setActiveImage(media);
    };

    return (
        <div className="media-container">
            <MediaThumbnailsSync videos={videos} thumbnailCallback={(data) => {
                setVideoThumbnails(prevState => {
                    return {...prevState, ...data};
                });
            }} />
            <div className="media-web">
                <div className="media-selection-container">

                    {/** Media scroll up */}
                    <div className={`scroll-up ${list.length >= 5 ? 'clickable' : 'disabled'}`}  onClick={() => handleScroll('Up')}>
                        {upArrowIcon}
                    </div>

                    {/** List of all images */}
                    <div className="all-images" ref={imageScrollRef}>
                        {
                            list.map((media, index) =>
                                <div key={`image_${index}`} className={`select-container clickable d-flex align-items-center justify-content-center ${activeImage.id === media.id ? 'active' : ''}`} style={{ backgroundColor: media.type === 'video' ? "#392E2E" : 'transparent' }} onClick={() => { onImageClick(media); }}>
                                    {
                                        media.type === 'image' ?
                                            <img src={media.thumbnailurl ? media.thumbnailurl : media.url} alt={`item-image-${index}`} onError={(e) => {
                                                e.target.onerror = null; 
                                                e.target.src = 'thumbnail.png'; 
                                                }} loading="lazy"/> :
                                            media.id in videoThumbnails ? 
                                            <div className="media-thumbnail">
                                                <img className="thumbnail-image" src={videoThumbnails[media.id]} />
                                                <div className="play-icon" >
                                                    {playIcon}
                                                </div>
                                            </div> : null
                                    }
                                </div>
                            )
                        }
                    </div>

                    {/** Media scroll down */}
                    <div className={`scroll-down  ${list.length >= 5 ? 'clickable' : 'disabled'}`} onClick={() => handleScroll('Down')}>
                        {downArrowIcon}
                    </div>
                </div>

                {/** Media display area */}
                <div className={`media-display-area ${Array.isArray(list) && list.length == 0 ? 'white-bg' : ''}`}>
                    {
                        activeImage.type === "image" ?
                            <div className={`img-magnifier-container d-flex align-items-center justify-content-center`}>
                                {
                                    galleryInModal ? 
                                    <img src={activeImage.url} loading="lazy" alt="item-image" className={`media-image`} /> :
                                    <>
                                        {
                                            Array.isArray(list) && list.length == 1 && !list[0].id ? null :
                                            <div className={`img-magnifier-glass ${magnifierHide ? 'invisible' : ''}`}
                                                style={{ backgroundImage: `url(${activeImage.url})` }}
                                                ref={magnifier}
                                                onMouseMove={moveMagnifier}
                                                onMouseOut={(event) => toggleMagnifier(event, true, 'leave')}></div>
                                        }
                                        <img src={activeImage.url}
                                            loading="lazy"
                                            alt="item-image"
                                            className={`media-image`}
                                            ref={magnifierImage}
                                            onMouseMove={moveMagnifier}
                                            onMouseEnter={(event) => toggleMagnifier(event, false, 'enter')} />
                                    </>
                                }
                            </div> :
                            galleryInModal ?
                                <video key={activeImage.url} preload="none" autoPlay={true} controls disablePictureInPicture controlsList="nodownload" webkit-playsinline playsinline >
                                    <source src={activeImage.url}></source>
                                    Your browser does not support HTML video.
                                </video> :
                                activeImage.id in videoThumbnails ?
                                    <div className="position-relative d-flex align-items-center justify-content-center">
                                        <img src={videoThumbnails[activeImage.id]} alt="thumbnail-new" className="thumbnail-img"></img>
                                        <div className="position-absolute z-1 clickable" onClick={() => { setVideoPlayerModal(true); }}>
                                            {playIcon}
                                        </div>
                                    </div> : null
                    }
                </div>
            </div> 
            <div className="media-mobile">
                <div className={`media-display-area ${Array.isArray(list) && list.length == 0 ? 'white-bg' : ''}`}>
                    {
                        Array.isArray(list) && list.length > 0 ?
                        <Row className="horizontal-row" xs={1} ref={horizontalScrollRef}>
                            {
                                list.map((asset, index) => (
                                    <Col className="horizontal-col" >
                                        {
                                            asset.type === "image" ? 
                                            <img src={asset.url} alt="item-image" className={`media-image ${Array.isArray(list) && list.length == 0 ? 'no-image-css' : ''}`} /> :
                                            asset.id in videoThumbnails ? 
                                            <div className="media-thumbnail" onClick={() => {
                                                setActiveImage(asset);
                                                setVideoPlayerModal(true);
                                                }}>
                                                <img className="thumbnail-image" src={videoThumbnails[asset.id]} />
                                                <div className="play-icon" >
                                                    {playIcon}
                                                </div>
                                            </div> : null
                                        }
                                    </Col>
                                ))
                            }
                        </Row> : null
                    }
                </div>
                <PaginationDots scrollRef={horizontalScrollRef} loading={false} totalSize={list.length} pageSize={1} />
            </div>

            <Modal centered show={videoPlayerModal} animation={false} size="lg" onHide={() => setVideoPlayerModal(false)}>
            <div type="button" onClick={() => setVideoPlayerModal(false)} className="close" style={{fontSize:'2rem', paddingRight: '1rem'}} data-dismiss="modal" variant="outline-primary" aria-label="Close"><span aria-hidden="true">&times;</span></div>

                <Modal.Body className="media-display-area-modal d-flex flex-column align-items-center justify-content-center">
                    {
                        videoPlayerModal ? 
                        <VideoPlayer url={activeImage.url} /> : null
                    }
                </Modal.Body>
            </Modal>

        </div>
    );
};